import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas(filtros) {
        let url = `${api}/credenciados/gestores/contratacoes?unidade=${filtros.unidade
            }&gestor=${filtros.gestor
            }&dataDe=${filtros.dataDe ? filtros.dataDe : ''
            }&dataAte=${filtros.dataAte ? filtros.dataAte : ''
            }&situacao=${filtros.situacao
            }&periodo=${filtros.periodo}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(contratacaoId) {
        return axiosJwt
            .get(`${api}/credenciados/gestores/contratacoes/${contratacaoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    naoAditivarContratacao(codContratacao) {
        return axiosJwt
            .patch(
                `${api}/credenciados/gestores/contratacoes/${codContratacao}/naoaditivar`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarAditivo(solicitacaoAditivo) {
        return axiosJwt
            .post(
                `${api}/credenciados/gestores/solicitacoesaditivos`,
                solicitacaoAditivo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterOpcoesFiltros() {
        return axiosJwt
            .get(
                `${api}/credenciados/gestores/contratacoes/opcoesfiltros`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
